import { render, staticRenderFns } from "./WebsitesSingle.vue?vue&type=template&id=96283c8e"
import script from "./WebsitesSingle.vue?vue&type=script&lang=js"
export * from "./WebsitesSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports